<div class="teams">
  <ng-select [items]="teams"
             [multiple]="true"
             [clearable]="false"
             [searchable]="false"
             [closeOnSelect]="false"
             [placeholder]="'HEADER.teams' | translate"
             [(ngModel)]="selectedTeams"
             (change)="onChangeTeams()"
             class="teams__select">
    <ng-template ng-header-tmp>
      <div class="teams__header">
        <span>{{ 'HEADER.select_label' | translate }}</span>
        <span class="teams__header--toggle-select"
              (click)="onToggleTeams()">
            <ng-container *ngIf="selectedTeams.length">
              {{ 'HEADER.clear_all' | translate }}
            </ng-container>
            <ng-container *ngIf="!selectedTeams.length">
              {{ 'HEADER.select_all' | translate }}
            </ng-container>
          </span>
      </div>
    </ng-template>

    <ng-template ng-multi-label-tmp let-items="items">
      <div class="teams__label">
        {{ 'HEADER.teams' | translate }} <span class="teams__label--number">{{ items.length}}</span>
      </div>
    </ng-template>


    <ng-template ng-option-tmp let-item="item" let-item$="item$" let-index="index">
      <div class="form-check">
        <input id="item2-{{index}}"
               type="checkbox"
               class="form-check-input input-primary me-2"
               [ngModel]="item$.selected">
        <span class="form-check-label">{{ item }}</span>
      </div>
    </ng-template>
  </ng-select>
</div>
